import Vue from 'vue'

import { QrcodeStream } from 'vue-qrcode-reader'

Vue.component('qr-code-stream', QrcodeStream)
